<div class="main-action-buttons">
  <button mat-icon-button type="button" matTooltip="Agregar Item" (click)="selectProduct()">
    <mat-icon class="icon-primary">add</mat-icon>
  </button>
  @if (original()?.length) {
    <button mat-icon-button type="button" matTooltip="Restablecer productos" (click)="resetProducts()">
      <mat-icon>restore</mat-icon>
    </button>
  }
</div>


<div class="category-mobile hide-desktop" [formGroup]="formArray() | formGroup">
  @for (product of formArray().controls; track product.getRawValue()) {
    <div class="mobile-product">
      <mat-icon class="mobile-delete-icon icon-error" (click)="removeItem($index)" aria-label="Eliminar producto">
        delete
      </mat-icon>
      <div class="mobile-move-icons">
        <mat-icon class="move-icon icon-primary" (click)="moveItemUp($index)" aria-label="Mover item arriba">
          arrow_upward
        </mat-icon>
        <mat-icon class="move-icon icon-primary" (click)="moveItemDown($index)" aria-label="Mover item abajo">
          arrow_downward
        </mat-icon>
      </div>
      <div class="data-row" >
        <div class="product-info">
          <div class="product-name">
            <span class="value">{{ product.get('product.code').value }}</span>
          </div>
          <div class="description">
            <mat-form-field appearance="outline" class="no-subscript mobile-field">
              <textarea matInput [formControl]="product.get('product.name') | formGroup"></textarea>
            </mat-form-field>
          </div>
        </div>
  
        <div class="total-mobile">
          <span class="label">Subtotal:</span>
          <span class="value">{{ getItemTotal($index) | money }}</span>
        </div>
      </div>
  
      <!-- Campos modificables -->
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ displayedColumns["quantity"] }}</mat-label>
          <input matInput type="number" min="0" [formControl]="product.get('quantity') | formGroup">
        </mat-form-field>
  
        <mat-form-field appearance="outline">
          <mat-label>{{ displayedColumns["amount"] }}</mat-label>
          <input matInput currencyMask [formControl]="product.get('amount') | formGroup" autocomplete="off">
        </mat-form-field>

        <td>
          <mat-form-field appearance="outline">
            <mat-label>{{ displayedColumns["discount_percent"] }}</mat-label>
            <input matInput type="number" min="0" max="100" [formControl]="product.get('discount_percent') | formGroup">
            <span matSuffix>%&nbsp;</span>
          </mat-form-field>
        </td>
      </div>
    </div>
  }
</div>

<div class="hide-mobile">
  <table class="table" [formGroup]="formArray() | formGroup">
    <thead>
      <tr>
        @for (column of columnsNames; track column) {
          <th>  
            {{ displayedColumns[column] }}
          </th>
        }
      </tr>
    </thead>
    
    <tbody>
      <tr class="separator-row">
        <td colspan="100"></td>
      </tr>
      @for (product of formArray().controls; track product) {
        <tr [formGroupName]="$index">
          <td class="move-actions-column">
            <mat-icon class="move-icon icon-primary" (click)="moveItemUp($index)" aria-label="Mover item arriba">
              arrow_upward
            </mat-icon>
            <mat-icon class="move-icon icon-primary" (click)="moveItemDown($index)" aria-label="Mover item abajo">
              arrow_downward
            </mat-icon>
          </td>
          <td>
            <div class="product">
              <mat-form-field appearance="outline" class="no-subscript">
                <textarea matInput [formControl]="product.get('product.name') | formGroup"></textarea>
              </mat-form-field>
            </div>
          </td>
          <td>
            <mat-form-field appearance="outline" class="quantity no-subscript">
              <input matInput type="number" min="0" [formControl]="product.get('quantity') | formGroup">
            </mat-form-field>
          </td>
          
          <td>
            <mat-form-field appearance="outline" class="amount no-subscript">
              <input matInput currencyMask [formControl]="product.get('amount') | formGroup" autocomplete="off">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="outline" class="discount-form-field">
              <input matInput type="number" min="0" max="100" [formControl]="product.get('discount_percent') | formGroup">
              <span matSuffix>%&nbsp;</span>
            </mat-form-field>
          </td>
          <td class="subtotal">
            {{ getItemTotal($index) | money }}
          </td>
          <td class="actions-column">
            <button mat-icon-button type="button" (click)="removeItem($index)" aria-label="Eliminar producto">
              <mat-icon class="icon-error">delete</mat-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="totals">
  <div class="total">
    <span>Neto:</span>
    <span>{{ Total | money }}</span>
  </div>
  <div class="tax">
    <span>IVA:</span>
    <span>{{ (Total * Tax) - Total | money }}</span>
  </div>
  <div class="final-total">
    <span>Total:</span>
    <span>{{ (Total * Tax) | money }}</span>
  </div>
</div>
